module.exports = __webpack_public_path__ + "media/images/flags/uz-4e36fd773931aea79047c4facf8701fa.svg";